import { useEffect, useState } from "react";
import { QuestionIcon } from "../Icons/QuestionIcon";
import { TickIcon } from "../Icons/TickIcon";
import { ToolTip } from "../ToolTip/ToolTip";

export interface CheckboxProps {
    label?: string;
    defaultIsChecked?: boolean;
    value?: boolean;
    handleChange?: (value: boolean) => void;
    testId?: string;
    tooltip?: string;
}

export const Checkbox = ({ value, label, defaultIsChecked, handleChange, testId, tooltip }: CheckboxProps) => {
    const [checked, setChecked] = useState(!!defaultIsChecked);

    const handleClick = () => {
        setChecked(!checked);
        handleChange && handleChange(!checked);
    };

    useEffect(() => {
        if (typeof value === "undefined") return;
        setChecked(value);
    }, [value]);

    return (
        <div
            data-testid={testId ? testId : "checkbox-container"}
            className="inline-flex items-center gap-2 cursor-pointer select-none"
            onClick={handleClick}
        >
            <input checked={checked} data-testid="checkbox-input" type="checkbox" className="hidden" readOnly={true} />
            <button
                data-testid={`checkbox-display`}
                className={`border-slate-400 border inline-flex items-center justify-center ${
                    checked ? "bg-blue dark:bg-darkPrimary-200" : "bg-white"
                } overflow-hidden`}
                style={{
                    height: "16px",
                    width: "16px",
                    borderRadius: "4px",
                }}
            >
                <TickIcon fill={checked ? "white" : "transparent"} />
            </button>

            {label && (
                <div className="" data-testid="checkbox-label">
                    {label}
                </div>
            )}

            {tooltip && (
                <ToolTip text={tooltip}>
                    <QuestionIcon />
                </ToolTip>
            )}
        </div>
    );
};
